import {Action} from "@ngrx/store";
import {PageVersionEventModel} from "@services/notifications/model/pageVersionEventModel";
import { HttpErrorResponse } from "@angular/common/http";
import {VersionEventModel} from "@services/notifications/model/versionEventModel";
import {PaginationModel} from "@shared/models/pagination.model";
export enum VersionHistoryActionTypes {
    LoadVersionHistory = '[VersionHistory] Load Version History',
    LoadVersionHistorySuccess = '[VersionHistory] Load Version History Success',
    LoadVersionHistoryFailure = '[VersionHistory] Load Version History Failure',
    ChangePage = '[VersionHistory] Change Page',
    AddVersion = '[VersionHistory] Add Version',
    AddVersionSuccess = '[VersionHistory] Add Version Success',
    AddVersionFailure = '[VersionHistory] Add Version Failure',
    EditVersion = '[VersionHistory] Edit Version',
    EditVersionSuccess = '[VersionHistory] Edit Version Success',
    EditVersionFailure = '[VersionHistory] Edit Version Failure',
    DeleteVersion = '[VersionHistory] Delete Version',
    DeleteVersionSuccess  = '[VersionHistory] Delete Version Success',
    DeleteVersionFailure   = '[VersionHistory] Delete Version Failure',
    SetInitialState = '[VersionHistory] Set Initial State',
}

export class LoadVersionHistory implements Action {
    readonly type = VersionHistoryActionTypes.LoadVersionHistory;
    constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadVersionHistorySuccess implements Action {
    readonly type = VersionHistoryActionTypes.LoadVersionHistorySuccess;
    constructor(public payload: PageVersionEventModel) {}
}

export class LoadVersionHistoryFailure implements Action {
    readonly type = VersionHistoryActionTypes.LoadVersionHistoryFailure;
    constructor(public payload: HttpErrorResponse) {}
}

export class ChangePage implements Action {
    readonly type = VersionHistoryActionTypes.ChangePage;
    constructor(public payload: PaginationModel) { }
}

export class AddVersion implements Action {
    readonly type = VersionHistoryActionTypes.AddVersion;
    constructor(public payload: VersionEventModel) {}
}

export class AddVersionSuccess implements Action {
    readonly type = VersionHistoryActionTypes.AddVersionSuccess;
    constructor(public payload: VersionEventModel) { }
}

export class AddVersionFailure implements Action {
    readonly type = VersionHistoryActionTypes.AddVersionFailure;
    constructor(public payload: HttpErrorResponse) { }
}

export class EditVersion implements Action {
    readonly type = VersionHistoryActionTypes.EditVersion;
    constructor(public payload: VersionEventModel) {}
}

export class EditVersionSuccess implements Action {
    readonly type = VersionHistoryActionTypes.EditVersionSuccess;
    constructor(public payload: VersionEventModel) { }
}

export class EditVersionFailure implements Action {
    readonly type = VersionHistoryActionTypes.EditVersionFailure;
    constructor(public payload: HttpErrorResponse) { }
}

/** Delete Version */
export class DeleteVersion implements Action {
    readonly type = VersionHistoryActionTypes.DeleteVersion;
    constructor(public payload: string) {}
}

export class DeleteVersionSuccess implements Action {
    readonly type = VersionHistoryActionTypes.DeleteVersionSuccess;
    constructor(public payload: void) { }
}

export class SetInitialState implements Action {
    readonly type = VersionHistoryActionTypes.SetInitialState;
}

export class DeleteVersionFailure implements Action {
    readonly type = VersionHistoryActionTypes.DeleteVersionFailure;
    constructor(public payload: HttpErrorResponse) { }
}

export type VersionHistoryActions =
    | LoadVersionHistory
    | LoadVersionHistorySuccess
    | LoadVersionHistoryFailure
    | ChangePage
    | AddVersion
    | AddVersionSuccess
    | AddVersionFailure
    | EditVersion
    | EditVersionSuccess
    | EditVersionFailure
    | DeleteVersion
    | DeleteVersionSuccess
    | DeleteVersionFailure
    | SetInitialState
    ;
